<template>
	<div
		v-if="isAvailableEventsMoreThanOne"
		class="block-card__control"
		@click="onSwitchView"
	>
		<div
			v-for="(event, eventType) in availableEvents"
			class="block-card__control-img"
		>
			<img
				:src="img(eventType)"
				:srcset="`${img(eventType)}, ${img2x(eventType)} 2x`"
				:alt="event?.name || ''"
				class="img img--cover"
			>
		</div>
	</div>
</template>

<script>

export default {
	name: 'BlockCardControl',
	props: {
		availableEvents: {
			type: Object,
			required: true
		},
		defaultImg: {
			type: String,
			default: () => this.availableEvents?.event?.logo?.url || this.availableEvents?.collection?.logo?.url || this.availableEvents?.studio?.logo?.url
		},
	},
	computed: {
		isAvailableEventsMoreThanOne() {
			return Object.keys(this.availableEvents).length > 1;
		}
	},
	methods: {
		onSwitchView() {
			this.$emit('on-switch-view-click');
		},
		img(eventType) {
			return `${this.$config.public.HOST_BACKEND}${this.availableEvents[eventType]?.logo?.url+'/s.webp' || this.defaultImg}`;
		},
		img2x(eventType) {
			return `${this.$config.public.HOST_BACKEND}${this.availableEvents[eventType]?.logo?.url+'/s2x.webp' || this.defaultImg}`;
		},
	}
}
</script>
